export default "__VITE_ASSET__D3oY7_B2__"